import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import SoundAssetKeys from '../SoundAssetKeys';

export default class Leaves extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.leaf1 = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._Leaf_1, this).setOrigin(0);
    this.leaf1.x = -42;
    this.leaf1.startX = -42;
    this.leaf1.y = 0;
    this.leaf1.startY = 0;

    this.leaf2 = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._Leaf_2, this).setOrigin(0);
    this.leaf2.x = -16;
    this.leaf2.startX = -16;
    this.leaf2.y = 50;
    this.leaf2.startY = 50;

    this.leaf3 = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._Leaf_3, this).setOrigin(0);
    this.leaf3.x = 120;
    this.leaf3.startX = 120;
    this.leaf3.y = 17;
    this.leaf3.startY = 17;

    this.leaf4 = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._Leaf_4, this).setOrigin(0);
    this.leaf4.x = 292;
    this.leaf4.startX = 292;
    this.leaf4.y = 54;
    this.leaf4.startY = 54;

    this.leaf5 = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._Leaf_5, this).setOrigin(0);
    this.leaf5.x = 727;
    this.leaf5.startX = 727;
    this.leaf5.y = 48;
    this.leaf5.startY = 48;

    this.leaf6 = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._Leaf_6, this).setOrigin(0);
    this.leaf6.x = 824;
    this.leaf6.startX = 824;
    this.leaf6.y = 12;
    this.leaf6.startY = 12;

    this.leaf7 = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._Leaf_7, this).setOrigin(0);
    this.leaf7.x = 888;
    this.leaf7.startX = 888;
    this.leaf7.y = 59;
    this.leaf7.startY = 59;
  }

  bounceLeaves() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._THUD, this.scene);

    ABCyaPhaser.Tweens.addTween(this.leaf1, 100, { delay: 15, y: this.leaf1.startY - 6 }, Phaser.Math.Easing.Quadratic.Out, () => {
      ABCyaPhaser.Tweens.addTween(this.leaf1, 300, { delay: Phaser.Math.Between(1, 40), y: this.leaf1.startY }, Phaser.Math.Easing.Quadratic.Out);
    });

    ABCyaPhaser.Tweens.addTween(this.leaf2, 100, { delay: 10, y: this.leaf2.startY - 6 }, Phaser.Math.Easing.Quadratic.Out, () => {
      ABCyaPhaser.Tweens.addTween(this.leaf2, 300, { delay: Phaser.Math.Between(1, 40), y: this.leaf2.startY }, Phaser.Math.Easing.Quadratic.Out);
    });

    ABCyaPhaser.Tweens.addTween(this.leaf3, 100, { delay: 5, y: this.leaf3.startY - 6 }, Phaser.Math.Easing.Quadratic.Out, () => {
      ABCyaPhaser.Tweens.addTween(this.leaf3, 300, { delay: Phaser.Math.Between(1, 40), y: this.leaf3.startY }, Phaser.Math.Easing.Quadratic.Out);
    });

    ABCyaPhaser.Tweens.addTween(this.leaf4, 100, { delay: 0, y: this.leaf4.startY - 6 }, Phaser.Math.Easing.Quadratic.Out, () => {
      ABCyaPhaser.Tweens.addTween(this.leaf4, 300, { delay: Phaser.Math.Between(1, 40), y: this.leaf4.startY }, Phaser.Math.Easing.Quadratic.Out);
    });

    ABCyaPhaser.Tweens.addTween(this.leaf5, 100, { delay: 10, y: this.leaf5.startY - 6 }, Phaser.Math.Easing.Quadratic.Out, () => {
      ABCyaPhaser.Tweens.addTween(this.leaf5, 300, { delay: Phaser.Math.Between(1, 40), y: this.leaf5.startY }, Phaser.Math.Easing.Quadratic.Out);
    });

    ABCyaPhaser.Tweens.addTween(this.leaf6, 100, { delay: 5, y: this.leaf6.startY - 6 }, Phaser.Math.Easing.Quadratic.Out, () => {
      ABCyaPhaser.Tweens.addTween(this.leaf6, 300, { delay: Phaser.Math.Between(1, 40), y: this.leaf6.startY }, Phaser.Math.Easing.Quadratic.Out);
    });

    ABCyaPhaser.Tweens.addTween(this.leaf7, 100, { delay: 0, y: this.leaf7.startY - 6 }, Phaser.Math.Easing.Quadratic.Out, () => {
      ABCyaPhaser.Tweens.addTween(this.leaf7, 300, { delay: Phaser.Math.Between(1, 40), y: this.leaf7.startY }, Phaser.Math.Easing.Quadratic.Out);
    });
  };
}